import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useAppSelector, selectors } from "store";
import { PsEsTooltip } from "ui/components/panels/canvas/overlay-elements/ps-es-tooltip";
import { CupTechnologyIndicator } from "ui/components/panels/canvas/overlay-elements/cup-technology-indicator";
var indicatorOffset = { x: 32, y: 0 };
export var GripPositionOverlay = function (_a) {
    var gripPosition = _a.gripPosition, isMoving = _a.isMoving, position = _a.position, width = _a.width;
    var isCentralizedSystem = useAppSelector(selectors.selectIsCentralizedSystem);
    var selectedPump = useAppSelector(selectors.selectSelectedDecentralPump(gripPosition.nodeId));
    var hasReachedPartSecured = useAppSelector(selectors.selectHasReachedPartSecured);
    var isPerformanceDataValid = useAppSelector(selectors.selectIsPerformanceDataValid);
    var selectedIds = useAppSelector(selectors.selectSelectedIds);
    var selectedCupTechnology = useAppSelector(selectors.selectSelectedCupTechnology(gripPosition.nodeId));
    var hasSelectedPump = selectedPump !== undefined;
    var showPartSecured = !isCentralizedSystem &&
        hasSelectedPump &&
        hasReachedPartSecured &&
        isPerformanceDataValid &&
        selectedIds.length === 0 &&
        !isMoving;
    return (_jsxs(_Fragment, { children: [showPartSecured && position ? (_jsx(PsEsTooltip, { anchorX: position.x, anchorY: position.y })) : null, selectedCupTechnology && position && width ? (_jsx(CupTechnologyIndicator, { anchorX: position.x + width + indicatorOffset.x, anchorY: position.y + indicatorOffset.y, cupTechnology: selectedCupTechnology })) : null] }));
};
